import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { TableMain } from "#core/components/table-main/TableMain"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { UseContextPromotionColaborador } from "#promotions/contexts/ContextPromotionColaborador"
import { promotionDetailsIdFileGet } from "#promotions/services/api"
import { Box, Button } from "@mui/material"
import { useMemo, useState } from "react"
import FileButtons from "./FileButtons"
import { FileFormDialog } from "./FileForm"
import { usePromotionsContext } from "#promotions/PromotionContext"

export default function Files({ autoFetch = true }) {
	const { detailId, reloadFiles } = UseContextPromotionColaborador()
	const { is_enabled } = usePromotionsContext()

	const [openFile, setOpenFile] = useState(false)
	const params = useMemo(() => ({ id: detailId }), [detailId])
	const { data, loading, error } = useApi(promotionDetailsIdFileGet, {
		autoFetch,
		params,
		reload: reloadFiles,
	})

	const options = {}
	if (is_enabled)
		options.customToolbar = () => (
			<Button variant="contained" color="primary" onClick={() => setOpenFile(true)}>
				Agregar Archivo
			</Button>
		)

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Box>
			<TableMain
				data={data.data || []}
				items={[
					{ name: "name", label: "Nombre" },
					{ name: "created_at", label: "Creado el" },
					{ name: "created_by_name", label: "Creado por" },
					{
						name: "",
						label: " ",
						options: {
							customBodyRender: (value, datum) => <FileButtons data={datum} />,
						},
					},
				]}
				{...{ options }}
			/>
			<FileFormDialog
				open={openFile}
				setOpen={setOpenFile}
				exclude={data.data.map((item) => item.file_type) || []}
			/>
		</Box>
	)
}

export function FilesDialog() {
	const { openFiles: open, setOpenFiles: setOpen } = UseContextPromotionColaborador()
	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				title: "Archivos de la promoción",
				maxWidth: "md",
			}}
		>
			<Files />
		</DialogMaster>
	)
}
